import { render, staticRenderFns } from "./cardSettings.vue?vue&type=template&id=1b757d1b&scoped=true"
import script from "./cardSettings.vue?vue&type=script&lang=js"
export * from "./cardSettings.vue?vue&type=script&lang=js"
import style0 from "./cardSettings.vue?vue&type=style&index=0&id=1b757d1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b757d1b",
  null
  
)

export default component.exports